import Axios from 'axios';
import header from './auth/header'

const API_URL =  process.env.API_URL + '/api/v1/';

class DataUsaha {
  update(data) {
    return Axios.patch(API_URL + 'update-datausaha', data, { headers: header() });
  }
}

export default new DataUsaha();



// WEBPACK FOOTER //
// ./src/api/datausaha.js